<template>
  <v-data-table
    class="elevation-1"
    style="cursor: pointer"
    :items="dailyReportVoyages"
    :headers="headers"
    :items-per-page="15"
    :mobile-breakpoint="dataTableMobileBreakpoint"
    @click:row="goToVoyageDetails"
    sort-by="voyageStartDateTimeLt"
    :search="search"
  >
    <template v-slot:top>
      <div class="d-flex text-start pa-4">
        <span class="headline primary--text font-weight-medium">
          <v-icon class="primary--text" left>mdi-ferry</v-icon>Voyages
        </span>
        <v-spacer></v-spacer>
        <v-text-field
          class="pa-0 ma-0"
          v-model="search"
          append-icon="mdi-magnify"
          label="Search"
          single-line
          hide-details
        ></v-text-field>
      </div>
    </template>
    <template v-slot:item.voyageStartDateTimeLt="{ item }">
      <span v-if="item.voyageStartDateTimeLt">{{
        item.voyageStartDateTimeLt | removeTAndSecondsAndFormatDate
      }}</span>
      <span v-else>Pending</span>
    </template>
    <template v-slot:item.status="{ item }">
      <div class="d-flex flex-row justify-start">
        <div class="status-chip-container">
          <v-chip :color="getStatusColour(item.status)" text-color="white">{{
            item.status | pascalToReadable
          }}</v-chip>
        </div>
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-icon
              v-if="item.isValid != undefined"
              class="mx-2"
              large
              :color="item.isValid ? 'success' : 'warning'"
              v-bind="attrs"
              v-on="on"
              >{{
                item.isValid
                  ? "mdi-check-circle-outline"
                  : "mdi-alert-circle-outline"
              }}</v-icon
            >
          </template>
          <span>{{
            item.isValid
              ? "Passed Validation Checks"
              : "Validation Errors Found"
          }}</span>
        </v-tooltip>
      </div>
    </template>
  </v-data-table>
</template>

<script>
import { mapGetters } from 'vuex';
import ResponsiveSizeHelperMixin from '../../mixins/ResponsiveSizeHelperMixin';
import StatusColourMixin from '../../mixins/StatusColourMixin';

export default {
  name: 'DailyVoyageReportVoyageTable',
  mixins: [StatusColourMixin, ResponsiveSizeHelperMixin],
  props: {
    dailyReportVoyages: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      search: '',
      headers: [
        { text: 'Voyage No', value: 'voyageNo' },
        { text: 'Vessel', value: 'vesselName' },
        { text: 'Start Date Time (LT)', value: 'voyageStartDateTimeLt' },
        { text: 'Initial Port', value: 'initialPort' },
        { text: 'Status', value: 'status' },
      ],
    };
  },
  methods: {
    goToVoyageDetails(item) {
      // Server Id or Client Id
      const { id } = item;
      const idc = item.idc ? item.idc.toString() : null;
      this.$router.push({ name: 'voyagedetails', params: { id, idc } });
    },
  },
};
</script>

<style scoped>
.status-chip-container {
  min-width: 100px;
}
</style>
